import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthService } from '../services/auth.service';
import { NavController } from '@ionic/angular';

@Injectable({
  providedIn: 'root',
})
export class ExternalTokenGuard implements CanActivate {
  constructor(private readonly authService: AuthService,
    public navController: NavController
  ) { }

  async canActivate(
    route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): Promise<boolean> {
    const tk = route.queryParamMap.get('qs');
    if (!tk) {
      this.authService.clearExternalSession();
      this.navController.navigateRoot('/login');
      return false;
    }
    return this.authService.validateExternalToken(tk);
  }
}
